(function () {
  const U = window.UIX;
  const RB = window.RB;
  const el = window.UIDOM.el;
  const esc = window.UIDOM.esc;

  const RUNE_TOTAL = 12;
  const FIELD_TOTAL = RB.Decklists.BATTLEFIELDS;
  const CURVE_BARS = 7;

  function pct(x, digits) {
    if (typeof x !== "number" || isNaN(x)) return "—";
    return (x * 100).toFixed(digits === undefined ? 1 : digits) + "%";
  }

  function cardOf(x) {
    if (x && typeof x === "object") return x;
    return x && RB.Setup ? RB.Setup.findCard(x) : null;
  }

  function cardName(id) {
    const c = cardOf(id);
    return c ? c.name.replace(/ - Starter$/, "") : id || "—";
  }

  function artImg(cardOrId, cls, opts) {
    const o = opts || {};
    const card = cardOf(cardOrId);
    const img = document.createElement("img");
    img.className = (cls || "") + " art";
    img.alt = card ? card.name : "";
    if (o.lazy !== false) img.setAttribute("loading", "lazy");
    img.setAttribute("decoding", "async");
    if (img.addEventListener) {
      img.addEventListener("load", function () { img.classList.add("ready"); });
    } else {
      img.onload = function () { img.classList.add("ready"); };
    }
    if (!card) return img;
    const animated = o.animated !== false && RB.hasAnimated(card);
    const srcset = RB.artSrcset ? RB.artSrcset(card, animated) : "";
    if (srcset) {
      img.sizes = o.sizes || "140px";
      img.srcset = srcset;
    }
    img.src = animated ? RB.artAnimated(card) : RB.art(card);
    if (img.complete) img.classList.add("ready");
    if (RB.artFallback) RB.artFallback(img, card);
    return img;
  }

  function apiGet(url, lax) {
    return fetch(url).then(function (r) {
      if (!r.ok && !lax) {
        const e = new Error(r.status + " " + r.statusText);
        e.url = url;
        e.status = r.status;
        throw e;
      }
      return r.json();
    });
  }

  function apiPost(url, body) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
  }

  function matrixCell(m, i, j, cls, style, legendOf) {
    const td = document.createElement("td");
    const n = (m.n && m.n[i] && m.n[i][j]) || 0;
    const p = m.wins[i][j];
    td.className = cls;
    const st = style(p, n, i === j);
    if (st !== null && st !== undefined) td.setAttribute("style", st);
    td.textContent = i === j ? "—" : pct(p, 0);
    const lo = m.lo && m.lo[i] ? m.lo[i][j] : null;
    const hi = m.hi && m.hi[i] ? m.hi[i][j] : null;
    td.title = cardName(legendOf(m.lists[i])) + " vs " + cardName(legendOf(m.lists[j])) + ": " +
      pct(p) + (typeof lo === "number" ? " [" + pct(lo) + ", " + pct(hi) + "]" : "") + " over " + n + " games";
    return td;
  }

  function sectionHead(cls, title, sub, subCls) {
    const h = el("div", cls);
    h.appendChild(el("h2", null, esc(title)));
    if (sub) h.appendChild(el("div", subCls || "mslbl", esc(sub)));
    return h;
  }

  function screenShell(id, title, subtitle) {
    const wrap = el("div", "msui");
    wrap.id = id;
    wrap.appendChild(el("div", "msweave"));
    const top = el("div", "mstop");
    top.appendChild(el("div", "mshair"));
    const home = el("button", "btn bbback", "<span>Menu</span>");
    home.onclick = function () { location.href = "/"; };
    top.appendChild(home);
    const brand = el("div", "msbrand");
    brand.appendChild(el("h1", null, title));
    brand.appendChild(el("div", "mslbl", subtitle));
    top.appendChild(brand);
    const acts = el("div", "mstopacts");
    top.appendChild(acts);
    wrap.appendChild(top);
    return { wrap: wrap, top: top, brand: brand, acts: acts };
  }

  function lineRib(cls, prefix, title, extra) {
    const r = el("div", cls);
    r.appendChild(el("span", prefix + "t", esc(title)));
    r.appendChild(el("span", prefix + "line"));
    if (extra) r.appendChild(extra);
    return r;
  }

  function deckCurve(deck) {
    const bars = [];
    for (let i = 0; i < CURVE_BARS; i++) bars.push(0);
    const buckets = [0, 0, 0, 0, 0, 0, 0, 0];
    let units = 0, spells = 0, gear = 0, sum = 0, n = 0;
    for (const id of deck.deck || []) {
      const card = RB.Setup.findCard(id);
      if (!card) continue;
      const cost = typeof card.energy === "number" ? card.energy : 0;
      bars[Math.min(CURVE_BARS - 1, Math.max(0, cost - 1))]++;
      buckets[Math.min(cost, 7)]++;
      const types = card.types || [];
      if (types.indexOf("unit") >= 0) units++;
      else if (types.indexOf("gear") >= 0) gear++;
      else spells++;
      sum += cost;
      n++;
    }
    return { bars: bars, buckets: buckets, units: units, spells: spells, gear: gear, total: n, avg: n ? sum / n : 0 };
  }

  function peakOf(bars) {
    let peak = 1;
    for (const n of bars) if (n > peak) peak = n;
    return peak;
  }

  function runeList(deck, cap) {
    const out = [];
    for (const dom of RB.Core.DOMAINS) {
      const have = (deck.runes || {})[dom] || 0;
      for (let i = 0; i < have && (cap === undefined || out.length < cap); i++) out.push(dom);
    }
    return out;
  }

  function slots(list, total, cap) {
    const out = list.slice(0, cap === undefined ? list.length : cap);
    while (out.length < total) out.push(null);
    return out;
  }

  function runeCard(dom) {
    return RB.Setup.findCard(RB.Decklists.RUNE_CARDS[dom]);
  }

  function refocusEnd(id) {
    const s = document.getElementById(id);
    if (s && s.focus) {
      s.focus();
      if (s.setSelectionRange) s.setSelectionRange(s.value.length, s.value.length);
    }
  }

  function searchField(o) {
    const input = document.createElement("input");
    input.type = o.type || "text";
    input.id = o.id;
    if (o.className) input.className = o.className;
    input.placeholder = o.placeholder;
    input.value = o.value || "";
    input.oninput = function () {
      o.onInput(input.value, input.selectionStart);
      if (o.refocus !== false) refocusEnd(o.id);
    };
    if (o.onKeydown) input.onkeydown = o.onKeydown;
    return input;
  }

  function placeFloating(m, r, o) {
    const mr = m.getBoundingClientRect();
    const pad = o.pad;
    let left, top;
    if (o.side === "right") {
      left = r.right + pad;
      if (left + mr.width > window.innerWidth - 8) left = r.left - mr.width - pad;
      if (left < 8) left = Math.max(8, Math.min(r.left + r.width / 2 - mr.width / 2, window.innerWidth - mr.width - 8));
      top = r.top + r.height / 2 - mr.height / 2;
      top = Math.max(8, Math.min(top, window.innerHeight - mr.height - 8));
    } else {
      left = r.left + r.width / 2 - mr.width / 2;
      top = r.top - mr.height - pad;
      if (top < 8) top = r.bottom + pad;
      if (top + mr.height > window.innerHeight - 8) top = Math.max(8, window.innerHeight - mr.height - 8);
      left = Math.max(8, Math.min(left, window.innerWidth - mr.width - 8));
    }
    m.style.left = Math.round(left) + "px";
    m.style.top = Math.round(top) + "px";
  }

  function starButton(deck, cls, onTitle, offTitle) {
    const on = RB.Decklists.isFavorite(deck.id);
    const b = el("span", cls + (on ? " on" : ""), on ? U.STAR_ON : U.STAR_OFF);
    b.title = on ? onTitle : offTitle;
    b.onclick = function (e) {
      e.stopPropagation();
      RB.Decklists.toggleFavorite(deck.id);
      U.render();
    };
    return b;
  }

  const STAR_ON = "<svg viewBox='0 0 24 24' fill='currentColor'><path d='M12 3l2.6 6.3 6.8.5-5.2 4.4 1.6 6.6L12 17.3 6.2 20.8l1.6-6.6L2.6 9.8l6.8-.5z'></path></svg>";
  const STAR_OFF = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.8' stroke-linejoin='round'><path d='M12 3.6l2.4 5.8 6.3.5-4.8 4.1 1.5 6.1L12 16.9l-5.4 3.2 1.5-6.1-4.8-4.1 6.3-.5z'></path></svg>";

  RB.Api = { get: apiGet, post: apiPost };
  Object.assign(U, { RUNE_TOTAL: RUNE_TOTAL, FIELD_TOTAL: FIELD_TOTAL, CURVE_BARS: CURVE_BARS, pct: pct, cardOf: cardOf, cardName: cardName, artImg: artImg, matrixCell: matrixCell, sectionHead: sectionHead, screenShell: screenShell, lineRib: lineRib, deckCurve: deckCurve, peakOf: peakOf, runeList: runeList, slots: slots, runeCard: runeCard, refocusEnd: refocusEnd, searchField: searchField, placeFloating: placeFloating, starButton: starButton, STAR_ON: STAR_ON, STAR_OFF: STAR_OFF });
})();
